export const getStyle = (_, { palette }) => ({
  '@global': {
    '& .app-content-container-col .default-layout': {
      'overflow-y': 'hidden',
    },
  },
  stepContainer: {
    '& .collapse-panel': {
      maxWidth: 1000,
    },
  },
  locationTargetTitle: {
    fontWeight: 600,
    marginBottom: 8,
  },
  locationTargetControl: {
    '& .specific-location-targets-editor': {
      marginLeft: '0px !important',
    },
  },
  languageTargetTitle: {
    fontWeight: 600,
    marginBottom: 8,
  },
  targetingPage: {
    '& .interests': {
      '& .collapse-content.content-show': {
        overflow: 'visible',
      },
    },
  },
  interestsSection: {
    marginRight: 26,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    // maxWidth: 680,
    '& .title-item': {
      width: 'auto',
      maxWidth: '100%',
    },
    '& .error-string-wrapper': {
      left: '160px',
      right: '46px',
      display: 'flex',
      '& span': {
        marginLeft: 'auto',
      },
    },
    '& .collapse-panel': {
      padding: 0,
      '& .collapse-title-bar': {
        padding: 24,
      },
      '& .helpbutton': {
        '&::before': {
          verticalAlign: 'initial',
        },
      },
      '& .collapse-content.content-show': {
        padding: '16px 24px',
      },
    },
    '& .audience-dimensions': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '4px',
      margin: '8px 0',

      '& .audience-dimension': {
        alignItems: 'center',
        backgroundColor: palette.neutralLighter,
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'row',
        gap: '6px',
        fontWeight: 600,
        padding: '6px 2px 6px 12px',

        '& button': {
          color: palette.neutralSecondary,
          height: 'auto',

          '& .ms-Icon': {
            fontSize: 12,
          },
        },
      },
    },
  },
  // 'interestsSection-l': {
  //   marginRight: 0,
  // },
  // 'interestsSection-m': {
  //   marginRight: 0,
  //   width: '100%',
  // },
  // 'interestsSection-s': {
  //   marginRight: 0,
  //   width: '100%',
  // },

  interestsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 14,
  },
  tooltip: {
    padding: '12px 5px',

    '& .tooltip-header': {
      paddingBottom: 8,
      borderBottom: `1px solid ${palette.neutralLight}`,
      marginBottom: 8,

      '& .interest-category': {
        fontSize: 10,
        lineHeight: '14px',
      },

      '& .interest-name': {
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '22px',
      },
    },

    '& .interest-reach': {
      fontSize: 14,
      lineHeight: '20px',

      '& span': {
        fontWeight: 600,
      },
    },
  },
});
